<div class="print-wrapper" style="direction: rtl; padding: 2em; font-size: 14px; font-family: 'Assistant', sans-serif; color: black;" *ngIf="concentForm" [formGroup]="concentForm">

  <!-- Clinic header: custom HTML header when configured, otherwise the clinic logo -->
  <div [innerHtml]="altHeader" *ngIf="altHeader"></div>
  <div *ngIf="!altHeader && env && env['haslogo']" style="margin-bottom: 0.8em; text-align: center;">
    <img src="/api/logo" alt="Logo" style="max-height: 80px; max-width: 100%;" />
  </div>

  <h2 style="text-align: center; margin-bottom: 0.7em; font-weight: bold;">{{ consentDef.title }}</h2>

  <!-- Patient info -->
  <div style="display: flex; gap: 2em; margin-bottom: 0.7em; flex-wrap: wrap;">
    <div><strong>שם משפחה:</strong> {{ concentForm.get('Last').value }}</div>
    <div><strong>שם פרטי:</strong> {{ concentForm.get('First').value }}</div>
    <div><strong>ת.ז.:</strong> {{ concentForm.get('ID').value }}</div>
    <div><strong>טלפון:</strong> {{ concentForm.get('Phone').value }}</div>
  </div>

  <!-- Consent body text -->
  <div class="section-text" style="margin-bottom: 0.5em;">
    <ng-container *ngFor="let block of consentDef.body">
      <h3 *ngIf="block.heading" style="font-weight: bold;">{{ block.heading }}</h3>
      <p *ngFor="let p of block.paragraphs">{{ p }}</p>
      <ul *ngIf="block.bullets">
        <li *ngFor="let b of block.bullets">{{ b }}</li>
      </ul>
    </ng-container>
  </div>

  <!-- Patient declaration -->
  <div style="margin-bottom: 0.5em;">
    <h3 style="font-weight: bold;">הצהרת המטופל וחתימות</h3>
    <p>אני מצהיר/ה כי:</p>
    <ul>
      <li>קיבלתי הסבר על מטרת הבדיקה, אופן ביצועה, יתרונותיה מגבלותיה והאלטרנטיבות.</li>
      <li>הוסברו לי הסיכונים ותופעות הלוואי האפשריים.</li>
      <li>ניתנה לי אפשרות לשאול שאלות, וכל שאלותיי נענו לשביעות רצוני.</li>
      <li *ngFor="let line of consentDef.consentLines">{{ line }}</li>
    </ul>
  </div>

  <!-- Doctor declaration + date/time -->
  <div style="margin-bottom: 0.5em;">
    <span>אני מצהיר/ה ומאשר/ת בזאת שקיבלתי הסבר מפורט בעל פה מ: </span>
    <strong>{{ concentForm.get('refferalDoc').value }}</strong>
  </div>
  <div style="display: flex; gap: 2em; margin-bottom: 0.4em;">
    <span><strong>יום:</strong> {{ concentForm.get('CreationTime').value | date:'EEEE' | translateDay }}</span>
    <span><strong>תאריך:</strong> {{ concentForm.get('CreationTime').value | date:'dd.MM.yyyy' }}</span>
    <span><strong>שעה:</strong> {{ concentForm.get('CreationTime').value | date:'HH:mm' }}</span>
  </div>

  <!-- Patient signature -->
  <div style="margin-bottom: 0.4em;">
    <div style="font-weight: bold; margin-bottom: 0.3em;">חתימת המטופל/ת:</div>
    <img *ngIf="concentForm.get('patSign').value"
         [src]="concentForm.get('patSign').value"
         style="width: 250px; height: 90px; border: 1px solid black; display: block;" />
    <div *ngIf="!concentForm.get('patSign').value"
         style="width: 250px; height: 90px; border: 1px solid black;"></div>
  </div>

  <!-- Doctor confirmation + signature (keep together) -->
  <div class="sig-box" style="border-top: 1px solid #ccc; padding-top: 0.5em; margin-top: 0.5em;">
    <div style="margin-bottom: 0.3em;">אני מאשר כי הסברתי למטופל/ת את מטרת הבדיקה, אופן ביצועה, מגבלותיה, הסיכונים האפשריים והמשך הבירור הצפוי במקרה של תוצאה חריגה, וכי התרשמתי שהמטופל/ת הבין/ה את ההסבר ונתן/ה הסכמה מדעת.</div>
    <div style="display: flex; gap: 2em; margin-bottom: 0.3em;">
      <span><strong>יום:</strong> {{ concentForm.get('CreationTime').value | date:'EEEE' | translateDay }}</span>
      <span><strong>תאריך:</strong> {{ concentForm.get('CreationTime').value | date:'dd.MM.yyyy' }}</span>
      <span><strong>שעה:</strong> {{ concentForm.get('CreationTime').value | date:'HH:mm' }}</span>
    </div>
    <div style="margin-bottom: 0.3em;"><strong>ד"ר:</strong> {{ concentForm.get('refferalDoc').value }}</div>
    <div style="font-weight: bold; margin-bottom: 0.2em;">חתימת הרופא/ה:</div>
    <img *ngIf="concentForm.get('docSign').value"
         [src]="concentForm.get('docSign').value"
         style="width: 250px; height: 90px; border: 1px solid black; display: block;" />
    <div *ngIf="!concentForm.get('docSign').value"
         style="width: 250px; height: 90px; border: 1px solid black;"></div>
  </div>

</div>
